module.exports = __webpack_public_path__ + "static/icons/icon-flights-ba2498169d5f455def62d18616122b5b.svg";